export const PREVIEW_STATE = {
  EMPTY: 'empty',
  INCOMPLETE: 'incomplete',
  INVALID: 'invalid',
  VALID: 'valid',
}

export const PREVIEW_REQUIRED_FIELDS = [
  { key: 'title', label: 'Назва кампанії' },
  { key: 'owner', label: 'Відповідальний' },
  { key: 'destinationUrl', label: 'URL призначення' },
  { key: 'channel', label: 'Канал' },
  { key: 'format', label: 'Формат' },
  { key: 'direction', label: 'Напрямок' },
]

export const getMissingPreviewFields = (values = {}) =>
  PREVIEW_REQUIRED_FIELDS.filter(({ key }) => !values[key]?.toString().trim())

export const hasRequiredForPreview = (values = {}) => getMissingPreviewFields(values).length === 0

const hasPreviewInput = (values = {}) =>
  Boolean(
    values.title ||
      values.owner ||
      values.destinationUrl ||
      values.channel ||
      values.format ||
      values.direction
  )

export const resolvePreviewState = ({ values, isValidCombination, canGenerateUtmParams }) => {
  if (!hasPreviewInput(values)) {
    return PREVIEW_STATE.EMPTY
  }

  const missingFields = getMissingPreviewFields(values)
  const hasValidTitleSlug = Boolean(values.title?.trim() && canGenerateUtmParams)

  if (missingFields.length > 0 || (values.title?.trim() && !hasValidTitleSlug)) {
    return PREVIEW_STATE.INCOMPLETE
  }

  if (!isValidCombination && values.channel && values.format) {
    return PREVIEW_STATE.INVALID
  }

  if (hasRequiredForPreview(values) && isValidCombination && canGenerateUtmParams) {
    return PREVIEW_STATE.VALID
  }

  return PREVIEW_STATE.INCOMPLETE
}

export default resolvePreviewState
